import { render, staticRenderFns } from "./kids_tournament_families.vue?vue&type=template&id=0e4bee7e"
import script from "./kids_tournament_families.vue?vue&type=script&lang=js"
export * from "./kids_tournament_families.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports